<template>
    <form
        class="site-search"
        role="search"
        @submit.prevent="submit"
    >
        <label
            class="site-search__label"
            :for="inputId"
        >{{ label }}</label>

        <KInput
            :id="inputId"
            v-model="query"
            class="site-search__input"
            type="search"
            name="search"
            :placeholder="placeholder"
        >
            <template #prefix>
                <Icon name="tabler:search" />
            </template>
        </KInput>
    </form>
</template>

<script setup>
import { KInput } from '@vemedia/karibu'
import { useId } from 'vue'
import './site-search.scss'

const { label = 'Search', placeholder = 'Search' } = defineProps({
    label: { type: String, default: 'Search' },
    placeholder: { type: String, default: 'Search' },
})

const emit = defineEmits(['search'])

const route = useRoute()

// Both copies of this form (bar and mobile drawer) mount at once, so the id has
// to be per-instance or the labels would point at the same input.
const inputId = `site-search-${useId()}`

// Seeded from the URL so the field still reflects the active query on /search,
// and kept in sync for client-side navigations between searches.
const query = ref(typeof route.query.search === 'string' ? route.query.search : '')

watch(() => route.query.search, (value) => {
    query.value = typeof value === 'string' ? value : ''
})

async function submit() {
    const trimmed = query.value.trim()

    if (!trimmed) {
        return
    }

    emit('search', trimmed)

    await navigateTo({ path: '/search', query: { search: trimmed } })
}
</script>
